module.exports = __webpack_public_path__ + "static/media/next.6c94a306.svg";